export default "__VITE_ASSET__D$FOT1j4__"